import { render, staticRenderFns } from "./DocPointDisplay.vue?vue&type=template&id=035b7425&scoped=true"
import script from "./DocPointDisplay.vue?vue&type=script&lang=js"
export * from "./DocPointDisplay.vue?vue&type=script&lang=js"
import style0 from "./DocPointDisplay.vue?vue&type=style&index=0&id=035b7425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035b7425",
  null
  
)

export default component.exports